import { createFileRoute, useParams } from '@tanstack/react-router';

import { EmptyState } from '@/components/ui.tsx';
import { useAuth } from '@/store/auth.ts';
import { TeacherGradeView } from '@/views/quizzes/teacher-grade-view.tsx';

// 某次尝试的教师评分页（手动 WR 分数 + 逐题反馈，
// 保存草稿 / 保存并发布）。深链接到此的学生看到空状态。
export const Route = createFileRoute('/_learner/courses_/$id/quizzes/$quizId/grade/$attemptId')({
  component: GradePage,
});

function GradePage() {
  const { id, quizId, attemptId } = useParams({
    from: '/_learner/courses_/$id/quizzes/$quizId/grade/$attemptId',
  });
  const user = useAuth((s) => s.user);
  if (!user) return null;
  if (user.role !== 'TEACHER') {
    return <EmptyState>Grading is only available to teachers.</EmptyState>;
  }
  return <TeacherGradeView courseId={id} quizId={quizId} attemptId={attemptId} />;
}
